module.exports = __webpack_public_path__ + "img/scj.f77a7004.png";